import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    UserName: '',
    Password: '',
    Sid: null,
    user_id: null,
    session_token: null,
    Processing: false,
    LoggedinAmbra: false,
    LoggedinDocPanel: false,
    LoginMessage: '',
    jwt: null,
    showTimeOutWarning: false
  },
  reducers: {
    updateUserName: (state, action)  => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.UserName = action.payload;
    },
    setShowTimeOutWarning: (state,action) => {
      state.showTimeOutWarning = action.payload;
    },
    updatePassword: (state, action) => {
      state.Password = action.payload;
    },
    "login/updateProcessing": (state, action) => {
      //just call 'updateProcessing'
      updateProcessing(state,action);
    },
    "login/logOut": (state, action) => {
      //just call 'updateProcessing'
      console.log('in login/logOut')
      logOut(state,action);
    },
    "updateProcessing": (state, action) => {
      state.Processing = action.payload;
      state.LoginMessage = (action.payload === false) ? 'Login Failed' : '';
    },
    "logindocpanel": (state, action) => {
     console.log(action.payload);
     const { user_id, session_token, jwt }  = action.payload;
     state.user_id = user_id
     state.session_token = session_token;
     state.LoggedinDocPanel = true;
     state.jwt = jwt;
     state.LoginMessage = '';
    },
    "logOut": (state, action) => {
      state.user_id = '';
      state.session_token = '';
      state.LoggedinDocPanel = false;
      state.jwt = '';
      state.LoginMessage = '';
      state.UserName = '';
      state.Password = '';
     },
     "refreshdocpanel": (state, action) => {
      console.log(action.payload);
      const { jwt }  = action.payload;
      state.LoggedinDocPanel = true;
      state.jwt = jwt;
      state.LoginMessage = '';
      console.log('refreshed ' + state.jwt )
     },
  },
});

export const { showTimeOutWarning, setShowTimeOutWarning, updateUserName, updatePassword, updateProcessing,loggedinDocPanel, logindocpanel, refreshdocpanel,jwt, logOut  } = loginSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const loginAsyncDocPanel = (UserName,Password) => dispatch => {

  dispatch(updateProcessing(true));
  dispatch(callLoginAPI({UserName,Password}))

};

export const refreshTokenAsyncDocPanel = (jwt) => dispatch => {

  dispatch(updateProcessing(true));
  dispatch(refreshTokenAPI({jwt}))

};


export const logOutAsyncDocPanel = () => dispatch => {
  dispatch(logOut(true));

};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectLoginData = state => state.login;

export const callLoginAPI = createAsyncThunk(
  'loginAPIcall', 
  async (Payload,thunkAPI) => {
  try {

    let { UserName, Password } = Payload;
 
    let data = {
      "login" : UserName,
      "password" : Password
      };

    const options = {
      'mode' : 'cors',
      'method' : 'post',
      headers: { 
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      'body': JSON.stringify(data),
    };
  
  const url = `${window.configs.api_server}/loginDocPanel`;
  let response = await (fetch(url,options).catch((err)=>{return {'status' : '500'}}));
  response = await response;
  console.log(response);
  //check if response is bad
  //if response was bad - not 200
  if ((!response.ok) || (response.status !== 200)) {
    thunkAPI.dispatch(updateProcessing(false));
    return;
  }

//we got a "ok" response, let's process it

  response = await response.json();

  if (
    (response.message === 'Login successful!')
     && (response.session_token)) {
      const {user_id, session_token, jwt } = response;
      thunkAPI.dispatch(updateProcessing(false));
      thunkAPI.dispatch(logindocpanel({session_token,user_id, jwt}))
       return;
      }
  else {
    thunkAPI.dispatch(updateProcessing(false));
    return;
  }
 
  } catch (error) {
    console.error(error);
      thunkAPI.dispatch(updateProcessing(false));
  }

  return;
})

export const refreshTokenAPI = createAsyncThunk(
  'refreshTokenAPIcall', 
  async (Payload,thunkAPI) => {
  try {

    let { jwt } = Payload;
 
    let data = {
       jwt
     };


    const options = {
      'mode' : 'cors',
      'method' : 'post',
      headers: { 
        "Authorization" : `Bearer ${jwt}`,  
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  			'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      'body': JSON.stringify(data),
    };
  
  const url = `${window.configs.api_server}/refreshTokenDocPanel`;
  let response = await (fetch(url,options).catch((err)=>{return {'status' : '500'}}));
  response = await response.json();
  //check if response is bad
  //if response was bad - not 200
  console.log(response.status);
  if (response.status === 200) {
    let { jwt } = response;
    console.log('received from refresh api call')
    console.log('sent back jwt as ' + jwt)
    thunkAPI.dispatch(updateProcessing(false));
    thunkAPI.dispatch(setShowTimeOutWarning(false));
    thunkAPI.dispatch(refreshdocpanel({jwt}));
    return
  }
  else 
  {
    thunkAPI.dispatch(updateProcessing(false));
    return;
  }

//we got a "ok" response, let's process it



 
  } catch (error) {
    console.error(error);
      thunkAPI.dispatch(updateProcessing(false));
  }

  return;
})



export default loginSlice.reducer;
